import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const Line = ({ children, delay }) => (
  <span className="block overflow-hidden">
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: [0.76, 0, 0.24, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const PageHeader = ({ eyebrow, title, intro }) => (
  <section className="pt-36 md:pt-52 pb-12 md:pb-20" data-testid="page-header">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="text-xs uppercase tracking-[0.35em] text-champagne mb-6 md:mb-10"
      >
        {eyebrow}
      </motion.p>
      <h1 className="font-serif font-light leading-[0.9] tracking-tight text-6xl md:text-8xl lg:text-[7.5vw]">
        {title.map((l, i) => (
          <Line key={i} delay={0.15 + i * 0.12}>{l}</Line>
        ))}
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6, ease }}
          className="mt-8 md:mt-12 max-w-xl text-base md:text-lg font-light text-ink/70 leading-relaxed"
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
